import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import { issueCertificates } from '../../../../slice/certificateIssuerHomeSlice';
import './IssueCertsConfirmation.css';

function IssueCertsConfirmation(props) {
  const dispatch = useDispatch();
  const { handleClose, eventId, eventName, isOpen } = props;

  const handleIssueCerts = async() => {
    const res = (await dispatch(issueCertificates(eventId))).payload;
    if (res.ok) {
      handleClose(true);
    }
  };

  return (
    <AlertDialog isOpen={isOpen} onClose={handleClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Issue Certificates: {eventName}
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can&apos;t undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={handleClose}>
                Cancel
              </Button>
              <Button colorScheme='red' onClick={handleIssueCerts} ml={3}>
                Issue
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
  );
}

IssueCertsConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  eventId: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired
};

export default IssueCertsConfirmation;
